import { gql } from '@apollo/client';

export default gql`
  query invitedSpaces($page: Int) {
    invitedSpaces(page: $page) {
      spacesTotalPages
      spacesTotal
      perPage
      hasNextPage
      currentPage
      spaces {
        id
        name
        role
        usersTotal
      }
    }
  }
`;
